export const MAX_PHONE_INPUT_DIGITS = 11;
export const PHONE_INPUT_LIMIT_ERROR = 'Maximum 11 digits. That entry was not accepted.';
export const PHONE_INPUT_ERROR = 'Enter exactly 10 digits, without a country code.';

export function getPhoneDigits(value: string): string {
  return value.replace(/\D/g, '');
}

export function exceedsPhoneInputLimit(value: string): boolean {
  return getPhoneDigits(value).length > MAX_PHONE_INPUT_DIGITS;
}

export function isValidPhone(value: string): boolean {
  return getPhoneDigits(value).length === 10;
}

/** Keep the phone mask's spacing, including every overflow digit for correction. */
export function formatPhoneInput(value: string): string {
  const digits = getPhoneDigits(value);
  return [digits.slice(0, 3), digits.slice(3, 6), digits.slice(6)]
    .filter(Boolean)
    .join(' ');
}

/** Restore the caret beside the same digit after inserting formatting spaces. */
export function phoneCaretPosition(formatted: string, digitsBeforeCaret: number): number {
  if (!digitsBeforeCaret) return 0;
  let count = 0;
  for (let i = 0; i < formatted.length; i += 1) {
    if (/\d/.test(formatted[i])) count += 1;
    if (count === digitsBeforeCaret) return i + 1;
  }
  return formatted.length;
}
